import { gql } from '@apollo/client/core'

export const DepositUpdate = gql`
  subscription DepositUpdate($entityUuid: ID!) {
    onDepositUpdate(entityUuid: $entityUuid) {
      siteName
      id
      entityUuid
      timestamp
      skippedTimestamp
      status
      dailyTotals {
        date
        amount
      }
      reference
      collectedAmount
      feeAmount
      refundsAmount
      chargebacksAmount
      totalAmount
      owingAmount
      depositAmount
      accountName
      accountNumber
      accountLogo
      shortId
    }
  }
`
